import { appstr } from "../utils/appstr";
import { enumFolderStatus, enumMFAState, kAdminUser } from "../constants";
import { QAccessFolder } from "./QAccessFolder";
import { QAccessGroup } from "./QAccessGroup";
import { sortgroups } from "../utils/sortgroups";
import { ValidateEmailAddr } from "../utils/ValidateEmailAddr";
import { Globals } from "./Globals";

export class QAccessGroupMgr {
  constructor() {
    this.fGroupList = null;
    this.fGroupsClone = null;
    this.fChartAndViewsInfo = null;
    this.fOrgName = null;
    this.fDirectSigninEnabled = true;
    this.fMFARequired = false;
  }

  InitAccessGroupMgr(orgName) {
    this.fGroupList = [];
    this.fOrgName = orgName;
  }

  SetAccessGroupsFromJSON(JSONGroupInfo) {
    this.fGroupList = [];
    if (!JSONGroupInfo || typeof JSONGroupInfo === "string") return;
    var directSigninDisabled = JSONGroupInfo["directsigninenabled"] === false;
    this.SetDirectSignInEnabled(!directSigninDisabled);
    var mfaRequired = (JSONGroupInfo["mfa"] || {})["mfaRequired"] == true;
    this.SetMFARequired(mfaRequired);
    if ("groups" in JSONGroupInfo) JSONGroupInfo = JSONGroupInfo["groups"];
    this.fGroupsClone = JSON.parse(JSON.stringify(JSONGroupInfo));
    for (var aGroup in JSONGroupInfo) {
      var theGroupObj = new QAccessGroup();
      theGroupObj.InitAccessGroup();
      theGroupObj.fGroupID = aGroup;

      var theGroup = JSONGroupInfo[aGroup];
      theGroupObj.fGroupName = theGroup["name"];
      theGroupObj.fExportExcel = theGroup["canExportExcel"] === true;
      theGroupObj.fEditTemplates = theGroup["canEditTemplates"] === true;
      theGroupObj.fRowSec = theGroup["rowLevelSecurity"] === true;
      theGroupObj.fChartAccess = theGroup["chartAccess"];
      theGroupObj.fBranchLevelSecurity = theGroup["branchLevelSecurity"];
      theGroupObj.fAllowedViews = theGroup["views"];
      theGroupObj.fAllowedHighlights = theGroup["allowedHighlights"];
      theGroupObj.fAllowedFilters = theGroup["allowedFilters"];
      theGroupObj.fInteractiveFiltering = !(theGroup["interactiveFiltering"] === false);

      for (var aFolderIdx in theGroup["folders"]) {
        var theFolder = theGroup["folders"][aFolderIdx];
        var theFolderObj = new QAccessFolder();
        theFolderObj.InitFolder(theFolder["name"], theFolder["locked"]);
        theGroupObj.fFolderList.push(theFolderObj);
      }
      this.fGroupList.push(theGroupObj);
    }
  }

  RevertChanges() {
    this.SetAccessGroupsFromJSON(this.fGroupsClone);
  }

  SetAccessGroupsToJSON(groupInfo) {
    var securityData = {};
    for (var aGroup in groupInfo) {
      var updatedGroup = groupInfo[aGroup];
      var groupID = updatedGroup.fGroupID;
      var theSecurityObject = {};
      if (groupID in this.fGroupsClone) theSecurityObject = this.fGroupsClone[groupID];
      theSecurityObject["name"] = updatedGroup.fGroupName;
      theSecurityObject["canExportExcel"] = updatedGroup.fExportExcel;
      theSecurityObject["canEditTemplates"] = updatedGroup.fEditTemplates;
      theSecurityObject["rowLevelSecurity"] = updatedGroup.fRowSec;
      theSecurityObject["views"] = updatedGroup.fAllowedViews;
      theSecurityObject["branchLevelSecurity"] = updatedGroup.fBranchLevelSecurity;
      theSecurityObject["allowedHighlights"] = updatedGroup.fAllowedHighlights;
      theSecurityObject["allowedFilters"] = updatedGroup.fAllowedFilters;
      var folderList = [];
      for (var folderIdx in updatedGroup.fFolderList) {
        var aFolder = updatedGroup.fFolderList[folderIdx];
        var folderObj = {
          name: aFolder.fFolderName,
          locked: aFolder.fFolderLocked
        };
        folderList.push(folderObj);
      }
      theSecurityObject["folders"] = folderList;
      securityData[groupID] = theSecurityObject;
    }
    this.fGroupsClone = securityData;
    return securityData;
  }

  GetMFAState(user, returnEnumVal) {
    if (!user)
      // Identifies MFA State as a combination of user + org info.
      return;
    var mfaState = enumMFAState.notConfigured;
    var mfaObj = user["mfa"] || user["fMFA"] || {};
    if ([enumMFAState.enabledAuth, enumMFAState.overrideMFA].includes(mfaObj["backendMFAState"]))
      mfaState = mfaObj["backendMFAState"];
    // Only enabled and override are guaranteed to persist.
    else if (this.GetMFARequired())
      mfaState = !ValidateEmailAddr(user["email"] || user["fUserEmail"])
        ? enumMFAState.requiredInvalidEmail
        : enumMFAState.required;

    return returnEnumVal ? mfaState : this.GetMFALabel(mfaState);
  }

  GetMFALabel(mfaState) {
    var retStr = "notset";

    switch (mfaState) {
      case enumMFAState.notConfigured:
        retStr = "Not Configured";
        break;
      case enumMFAState.requiredInvalidEmail:
        retStr = "Valid Email Address Required";
        break;
      case enumMFAState.required:
        retStr = "Required & Not Configured";
        break;
      case enumMFAState.enabledAuth:
        retStr = "Active";
        break;
      case enumMFAState.overrideMFA:
        retStr = "Bypassed";
        break;
    }

    return appstr(retStr);
  }

  GetGroupCount() {
    return this.fGroupList.length;
  }

  GetIndexGroup(index) {
    return this.fGroupList[index];
  }

  AddAccessGroup(groupName) {
    var group = new QAccessGroup();
    group.InitAccessGroup();
    group.SetGroupName(groupName);
    this.fGroupList.push(group);
    this.fGroupList.sort(sortgroups);
    return group;
  }

  GetGroupByID(groupID) {
    var n = this.GetGroupCount();
    for (var i = 0; i < n; i++) {
      var g = this.GetIndexGroup(i);
      var id = g.GetGroupID();
      if (id == groupID) return g;
    }

    return null;
  }

  GetIDFromName(groupName) {
    groupName = groupName.toLowerCase();

    var noGroup = "<" + appstr("nogroup") + ">";
    noGroup.toLowerCase();
    if (groupName == noGroup) return -1;

    var fullAccess = appstr("fullaccess").toLowerCase();
    if (groupName == fullAccess) return "0";

    var n = this.GetGroupCount();
    for (var i = 0; i < n; i++) {
      var g = this.GetIndexGroup(i);
      var gN = g.GetGroupName();
      if (gN.toLowerCase() == groupName) return g.GetGroupID();
    }

    return -1;
  }

  NameUsed(groupName, ignoreGroup, addGroup) {
    groupName = groupName.toLowerCase();

    var fullAccess = appstr("fullaccess").toLowerCase();
    if (groupName == fullAccess) return true;

    var n = this.GetGroupCount();
    for (var i = 0; i < n; i++) {
      var g = this.GetIndexGroup(i);
      if (g != ignoreGroup || addGroup) {
        var gN = g.GetGroupName();
        if (gN.toLowerCase() == groupName) return true;
      }
    }
    return false;
  }

  GetGroupNameByID(groupID) {
    var accessGroup = this.GetGroupByID(groupID);
    var groupName;

    if (accessGroup == null) {
      if (groupID == "0") groupName = appstr("fullaccess");
      else {
        groupName = "<" + appstr("nogroup") + ">";
        groupID = -1;
      }
    } else groupName = accessGroup.GetGroupName();

    return groupName;
  }

  GetGroupInfo() {
    return this.fGroupList;
  }

  GetChartData() {
    return this.fChartAndViewsInfo;
  }

  DeleteAccessGroup(theGroup) {
    var index = this.fGroupList.indexOf(theGroup);
    if (index != -1) {
      this.fGroupList.splice(index, 1);
      return true;
    }

    return false;
  }

  ToggleFolderLock(theGroup, folderName) {
    theGroup.ToggleFolderLock(folderName);
  }

  AddFolderToGroup(theGroup, folderName) {
    theGroup.AddFolder(folderName);
  }

  RemoveFolderFromGroup(theGroup, folderName) {
    theGroup.RemoveFolder(folderName);
  }

  Clone() {
    var accessgc = new QAccessGroupMgr();
    accessgc.InitAccessGroupMgr(this.fOrgName);
    var n = this.GetGroupCount();
    for (var i = 0; i < n; i++) {
      var group = this.GetIndexGroup(i);
      var groupClone = group.Clone();
      accessgc.fGroupList(groupClone);
    }

    return accessgc;
  }

  GetIDList() {
    var groupList = [];
    for (var i in this.fGroupList) groupList.push(this.fGroupList[i].fGroupID);
    return groupList;
  }

  SetDirectSignInEnabled(bool) {
    this.fDirectSigninEnabled = bool;
  }

  GetDirectSignInEnabled() {
    return this.fDirectSigninEnabled;
  }

  SetMFARequired(bool) {
    this.fMFARequired = bool;
  }

  GetMFARequired() {
    return this.fMFARequired;
  }

  GetUniqueAccessGroupID() {
    var groupIDList = this.GetIDList();
    var uniqueID = 1;

    while (groupIDList.indexOf(uniqueID.toString()) > -1) uniqueID++;
    return uniqueID.toString();
  }

  CanAccessBackgroundEditor(curGroupID) {
    var ut = Globals._accountInfo.GetUserRole();
    var isAdmin = ut === kAdminUser;
    if (isAdmin) {
      return true;
    } else if (Globals._uiConfig.fHasWorkbench) {
      var fullAccessG = curGroupID == "0";
      if (fullAccessG) {
        return true;
      } else {
        var curGroup = this.GetGroupByID(curGroupID);
        var groupStatus = curGroup.FolderInGroup("Masters");
        if (groupStatus === enumFolderStatus.ingroup) return true;
      }
    }
    return false;
  }
}
